{
    "yes": "Sí",
    "no": "No",
    "confirm": "Confirmar",
    "apply": "Aplicar",
    "cancel": "Cancelar",
    "show": "Espectáculo",
    "hide": "Esconder",
    "send": "Enviar",
    "close": "Cerca",
    "edit": "Editar",
    "delete": "Borrar",
    "loading": "Cargando",
    "expand": "Expandir",
    "collapse": "Colapsar",
    "fullscreenEnter": "Entrar en pantalla completa",
    "fullscreenExit": "Salir de pantalla completa",
    "center": "Centro",
    "bottom": "Abajo",
    "hidden": "Oculto",
    "day": "Día",
    "all": "Todos",
    "today": "Hoy",
    "yesterday": "Ayer",
    "last_7_days": "Últimos 7 días",
    "last_30_days": "Últimos 30 días",
    "placeholder": "Haz una pregunta",
    "date": "Fecha de nacimiento",
    "month": "Mes",
    "copied": "¡Copiado!",
    "missingData": "Información faltante",
    "year": "Año",
    "createdAt": "Fecha de creación",
    "selected": "Seleccionado",
    "page": "página",
    "actions": "Comportamiento",
    "next": "Próximo",
    "previous": "Anterior",
    "copy": "Copiar",
    "copyRawCode": "Copiar código sin formato",
    "copyToClipboard": "Copiar al portapapeles",
    "showOriginalText": "Mostrar original",
    "showTranslatedText": "Mostrar traducción",
    "exactPosition": "Posición exacta",
    "uncertain": "Incierto",
    "question": "Pregunta",
    "nothingFound": "No se encontró nada",
    "venue": "Evento",
    "searchVenue": "Buscar lugar...",
    "privacyPolicy": "Política de privacidad",
    "popularLanguages": "Populares",
    "allLanguages": "Todos los idiomas",
    "memoriBlockedTitle": "Obstruido",
    "memoriBlockedUntil": "Agent bloqueado hasta {{date}}",
    "memoriBlockedAnon": "Actualmente \"{{name}}\"No puedo responder, vuelve aquí. {{date}}",
    "memoriBlockedReasonExceedChats": "porque ha superado el umbral mensual de chats permitidos.",
    "memoriBlockedGiverHelper": "Aún podrás administrarlo como administrador, pero otros usuarios no podrán interactuar con él.",
    "generatedByAI": "La respuesta generada por IA, ocasionalmente puede generar información incorrecta",
    "reasoning": "Pensamiento...",
    "whyThisAnswer": "¿Por qué esta respuesta?",
    "whyThisAnswerHelper": "Esta respuesta fue generada automáticamente por una inteligencia artificial basada en estos contenidos verificados.",
    "receiverLabel": "Asignado a",
    "completionsEnabled": "La IA avanzada puede responder con respuestas generadas automáticamente que a veces pueden contener información incorrecta.",
    "completionProviderDown": "Este Agent está integrado con una IA generativa de {{provider}}, pero actualmente no está disponible. ",
    "completionProviderMajorOutage": "Este Agent está integrado con una IA generativa de {{provider}}, pero al momento no está disponible. No será posible utilizar esta funcionalidad hasta que el servicio se restaure.",
    "completionProviderPartialOutage": "Este Agent está integrado con una IA generativa de {{provider}}, pero está experimentando interrupciones parciales. Algunas funcionalidades pueden no estar disponibles o funcionar de manera no óptima.",
    "completionProviderDegraded": "Este Agent está integrado con una IA generativa de {{provider}}, pero está funcionando más lentamente de lo normal. Las respuestas pueden tomar más tiempo o ser menos precisas.",
    "completionProviderFallbackName": "un proveedor externo",
    "completionProviderCheckStatusPage": "Comprobar página de estado",
    "boardOfExperts": "junta de expertos",
    "birthDate": "Fecha de nacimiento",
    "birthDateHelper": "Solicitamos tu fecha de nacimiento únicamente para habilitar o deshabilitar funcionalidades que tienen restricciones de edad.",
    "underage": "Debes ser al menos {{age}} años para inscribirse.",
    "underageTwinSession": "Debes ser al menos {{age}} años para interactuar con este gemelo.",
    "errorFetchingSession": "Error durante el cargamento de la sesión",
    "errorGettingReferralURL": "Error durante el cargamento del référent",
    "errorReopeningSession": "Error durante el re-abrir la sesión",
    "ageVerification": "Verificación de edad",
    "ageVerificationText": "Para interactuar con este Gemelo, debes tener al menos {{minAge}} años.",
    "nsfw": "NSFW: Este gemelo contiene contenido para adultos",
    "deepThought": "pensamiento profundo",
    "deepThoughtHelper": "Deep Thought es una característica avanzada de la IA que te permitirá explotar al máximo tus conversaciones al realizar un seguimiento de ellas. ",
    "deepThoughtDisclaimerTitle": "Pensamiento profundo habilitado",
    "deepThoughtDisclaimer": "Deep Thought es una característica avanzada de la IA que te permitirá explotar al máximo tus conversaciones al realizar un seguimiento de ellas. ",
    "deepThoughtPreDisclaimerUnlogged": "Inicie sesión para habilitar Pensamiento profundo.",
    "deepThoughtPreDisclaimerNotAllowed": "Deep Thought está deshabilitado porque usted no dio su consentimiento para su uso; puede cambiar esto en cualquier momento en la configuración de su cuenta.",
    "notEnoughCredits": "El autor de este Gemelo no tiene suficientes créditos para responder a tu pregunta.",
    "confirmDialog": {
        "title": "¿Quieres salir de esta página?",
        "message": "Los cambios que has realizado se perderán."
    },
    "knownFacts": {
        "title": "hechos conocidos",
        "description": "Detalles de la información compartida entre usted y {{memoriName}}",
        "type": "Tipo",
        "typeShortTerm": "Corto plazo",
        "typeLongTerm": "Largo plazo",
        "typeHelper": "Tipos:\n",
        "text": "Texto",
        "deleteSuccess": "Hecho conocido eliminado",
        "deleteConfirmTitle": "Eliminar hecho conocido",
        "deleteConfirmMessage": "¿Está seguro de que desea eliminar este hecho conocido?",
        "deleteSelectedConfirmTitle": "Eliminar hechos conocidos seleccionados",
        "deleteSelectedConfirmMessage": "¿Está seguro de que desea eliminar los hechos conocidos seleccionados?"
    },
    "auth": {
        "title": "Autenticación",
        "useRecoveryTokens": "Utilice tokens de recuperación",
        "tokens": "Fichas",
        "addToken": "Agregar token",
        "usePassword": "Usar contraseña",
        "passwordRequired": "Contraseña obligatoria",
        "invalidCredentials": "Credenciales no válidas",
        "atLeast": "Al menos"
    },
    "widget": {
        "instruct": "Instruir",
        "test": "Probar",
        "sound": "Sonido",
        "position": "Preferencias de posición",
        "settings": "Ajustes",
        "share": "Compartir",
        "shareChat": "Compartir chat",
        "sendOnKeypress": "Presiona Enter para enviar",
        "sendOnClick": "Haz clic en Enviar",
        "boardOfExperts": "Panel de expertos",
        "showExpertsInTheBoard": "Mostrar expertos en este panel",
        "expertsInTheBoard": "Expertos en este panel",
        "goToIntegrationsToCustomizeAvatar": "Para personalizar el avatar, ve a Compartir y personaliza la página pública"
    },
    "exportChatHistory": {
        "exportPDF": "Exportar chat como PDF",
        "exporting": "Exportando...",
        "empty": "No hay historial de chat para exportar",
        "pdfNotSupported": "La exportación PDF no es compatible con este navegador",
        "success": "Chat exportado a PDF exitosamente",
        "error": "Error al exportar el chat a PDF. Por favor, inténtalo de nuevo."
    },
    "write_and_speak": {
        "micButtonPopover": "Haga clic en el botón para hablar",
        "micButtonPopoverListening": "Haga clic en el botón para dejar de hablar.",
        "pageInstructExplanation": "Para enseñarme cosas nuevas, haga clic en el botón INSTRUIRME para comenzar.",
        "pageTryMeExplanation": "Para hablar conmigo haga clic en el botón INICIO para comenzar",
        "pagePrivacyExplanation": "Las conversaciones son visibles por el autor del agente",
        "pagePrivacyExplanationList": {
            "allConversations": "Todas las conversaciones con este agente son visibles por el autor del agente",
            "anonymousUser": "Para usuarios anónimos: el autor verá el contenido de la conversación y su dirección IP",
            "registeredUser": "Para usuarios registrados: el autor verá el contenido de la conversación y su nombre de usuario",
            "contentAndUsername": "El autor puede ver el contenido, tu nombre de usuario y tu dirección IP",
            "contentAndIpAddress": "El autor puede ver el contenido y tu dirección IP",
            "authorUsesInfo": "El autor utiliza estas informaciones para mejorar las funciones del agente y para ofrecerte un mejor servicio. Continuando la conversación, acepta estas condiciones."
        },
        "instructButton": "INSTRUÍME",
        "downloadChat": "Descargar chat",
        "tryMeButton": "COMENZAR",
        "resumeButton": "CONTINUAR",
        "chatHistory": "Historial de chat",
        "chatHistoryDescription": "Mostrar el historial de chat con este agente",
        "loadingChatHistory": "Cargando historial de chat...",
        "noChatHistoryAvailable": "No hay historial de chat disponible",
        "noResultsFound": "No se encontraron resultados para \"{{searchText}}\"",
        "searchInChatHistory": "Buscar en el historial de chat...",
        "latestFirst": "Más recientes primero",
        "oldestFirst": "Más antiguos primero",
        "exportChat": "Exportar Chat",
        "conversationStartedLabel": "Conversación iniciada",
        "settingsHeaderLabel": "Configure aquí si desea configurar la memoria como voz continua y cambie los segundos de silencio si desea personalizarlos.",
        "continuousSpeechLabel": "discurso continuo",
        "continuousSpeechDisabled": "Discurso continuo deshabilitado porque el agente está en modo silencioso",
        "holdToSpeak": "Mantenga para hablar",
        "releaseToEndListening": "Suelte para finalizar la escucha",
        "pressAndHoldToSpeak": "Mantenga presionado para hablar",
        "microphoneMode": "Modo micrófono",
        "hideEmissionsLabel": "Ocultar texto emitido por el Agent",
        "secondsLabel": "Establecer segundos",
        "controlsPosition": "Posición de los controles",
        "tryMeHeaderLabel": "INTENTAR",
        "unknownPosition": "Posición desconocida",
        "fieldPlace": "Escribe el lugar (por ejemplo, 'Milano')",
        "showMapLinkFor": "Mostrar la posición en el mapa.",
        "useMyPosition": "Usa mi posición",
        "myPosition": "Tu posición",
        "updatingPosition": "Actualizando posición...",
        "placeNotFound": "¡Lugar no encontrado!",
        "requirePosition": "Inserte su posición antes de comenzar",
        "requirePositionHelp": "para hablar con {{name}} usted tiene que decidir si proporciona su puesto o no. ",
        "dontWantToProvidePosition": "No quiero proporcionar mi puesto.",
        "attachmentsLabel": "Enriquece tu mensaje",
        "iWantToTalkToIn": "quiero hablar con {{name}} en",
        "message": "mensaje",
        "messages": "mensajes",
        "page": "Página {{current}} de {{total}}"
    },
    "artifact": {
        "close": "Cerrar",
        "size": "Tamaño",
        "generated": "Generado",
        "download": "Descargar",
        "print": "Imprimir",
        "external": "Abrir en una nueva ventana",
        "type": "Tipo",
        "fullscreen": "Pantalla completa",
        "exitFullscreen": "Salir de pantalla completa",
        "copy": "Copiar",
        "generatedAt": "Generado el",
        "open": "Abrir",
        "code": "Código",
        "preview": "Vista previa",
        "copied": "¡Copiado!",
        "error": "Error",
        "generatingPdf": "Generando PDF...",
        "copying": "Copiando...",
        "moreCopyOptions": "Más opciones de copia",
        "copyAs": "Copiar como",
        "downloadAsMarkdown": "Descargar como Markdown",
        "downloadRawMarkdownText": "Descargar texto markdown sin formato",
        "downloadAsPdf": "Descargar como PDF",
        "exportAsPdfDocument": "Exportar como documento PDF",
        "downloadAsHtml": "Descargar como HTML",
        "downloadFormattedHtml": "Descargar HTML formateado",
        "viewMode": "Modo Vista",
        "codeMode": "Modo Código",
        "refresh": "Actualizar",
        "share": "Compartir",
        "downloadAsJson": "Descargar como JSON",
        "downloadJsonData": "Descargar datos JSON",
        "downloadAsPng": "Descargar como PNG",
        "downloadPngImage": "Descargar imagen PNG",
        "downloadAsJpeg": "Descargar como JPEG",
        "downloadJpegImage": "Descargar imagen JPEG",
        "downloadAsGif": "Descargar como GIF",
        "downloadGifImage": "Descargar imagen GIF",
        "downloadAsWebp": "Descargar como WebP",
        "downloadWebpImage": "Descargar imagen WebP",
        "copyAsSvg": "Copiar como SVG",
        "copySvgSourceCode": "Copiar código fuente SVG",
        "copyAsPlainText": "Copiar como texto plano",
        "copyAsText": "Copiar como texto",
        "copyAsLanguage": "Copiar como {{language}}",
        "copyLanguageCode": "Copiar código {{language}}",
        "copyWithoutSyntaxHighlighting": "Copiar sin resaltado de sintaxis",
        "copyTextContent": "Copiar contenido de texto",
        "pdfExportNotSupported": "La exportación PDF no es compatible con este navegador",
        "popupBlocked": "¡Popup bloqueado! Por favor, habilita los popups para imprimir.",
        "safariPdfInstructions": "Exportación PDF abierta en nueva ventana. Por favor, usa Cmd+P (Mac) o Ctrl+P (Windows) para imprimir y guardar como PDF."
    },
    "upload": {
        "loginRequired": "Connexion requise",
        "pastedText": "texto-pegado",
        "uploadNotification": "Échec del téléchargement",
        "loginRequiredDescription": "Veuillez vous connecter pour télécharger des images",
        "uploadFiles": "Télécharger des fichiers ({{shortcut}}+O para abrir el selector de archivos)",
        "uploadFilesWithShortcut": "{{shortcut}}+O para abrir el selector de archivos",
        "uploadImages": "Télécharger des images",
        "uploadDocuments": "Télécharger des documents",
        "apiClientNotConfigured": "API client non configuré correctement pour le téléchargement de médias",
        "fileReadingFailed": "Échec de la lecture du fichier",
        "uploadFailed": "Échec du téléchargement",
        "uploadSuccess": "Téléchargement réussi",
        "uploadSuccessDescription": "Le fichier a été téléchargé avec succès",
        "replace": "Remplacer",
        "maxImagesReached": "Vous pouvez télécharger jusqu'à {{max}} images",
        "remaining": "restant",
        "maxReached": "Limite atteinte",
        "dragAndDropFiles": "Arrastre y suelte los archivos aquí para agregarlos a la chat",
        "contextSizeExceedsLimit": "El tamaño del contexto supera el límite. Intenta reducir el número de archivos o el contenido de la conversación.",
        "filesNotAddedMaxAllowed": "{{count}} archivo(s) no añadido(s) (máximo {{max}} archivos permitidos).",
        "documentsNotAddedMaxAllowed": "{{count}} documento(s) no añadido(s) (máximo {{max}} archivos permitidos).",
        "imagesNotAddedMaxAllowed": "{{count}} imagen(es) no añadida(s) (máximo {{max}} archivos permitidos).",
        "documentsNotAddedContextSize": "{{count}} documento(s) no añadido(s) (límite de tamaño de contexto)."
    },
    "media": {
        "title": "Título",
        "editAttributes": "Editar atributos de medios",
        "uploadMimeTypeNotAllowed": "El tipo de archivo no está permitido.",
        "uploadSizeLimitMessage": "El tamaño subido es demasiado grande (máx. {{size}}MEGABYTE)",
        "uploadWrongResolutionMessage": "La resolución debe ser {{width}}incógnita{{height}} píxel",
        "memoriNameAlreadyUsed": "Ya tienes un gemelo con este nombre.",
        "uploadHelperImages": "Sube un archivo con extensión png, jpg, jpeg o gif, y que tenga como máximo un tamaño de {{size}}MEGABYTE",
        "uploadHelper": "Cargue un archivo que tenga como máximo un tamaño de {{size}}MEGABYTE",
        "uploadError": "Error al subir",
        "square": "cuadrado",
        "scaleRatio": "Relación de escala",
        "addMediaLabel": "Agregar un medio",
        "insertThisMediaMsg": "Inserte estos medios",
        "mediaUploadMessage": "Haga clic para cargar un nuevo medio",
        "addLinkLabel": "Agregar un enlace",
        "linkKey": "URL",
        "linkValue": "Título del enlace",
        "insertThisLink": "Insertar un enlace a {{url}} con titulo {{title}}"
    },
    "gamification": {
        "level": "Nivel",
        "points": "agujas",
        "memoriReachedLevel": "se volvió más evolucionado y alcanzó el nivel",
        "levelGoToStatistics": "{{Agent}} esta al nivel {{level}} con {{points}} agujas. ",
        "congratulationsNewLevel": "¡Felicitaciones, has alcanzado un nuevo nivel!",
        "congratulationsNewLevelDescription": "Tu Agent se volvió más evolucionado con {{points}} puntos, mira el",
        "statistics": "estadística"
    },
    "login": {
        "login": "Acceso",
        "logout": "Cerrar sesión",
        "user": "Usuario",
        "loggedDrawerTitle": "Hola, {{name}}!",
        "loginDrawerTitle": "Acceso",
        "userNameRequired": "Nombre de usuario requerido",
        "userName": "Nombre de usuario",
        "userNamePlaceholder": "Ingrese el nombre de usuario",
        "signupDrawerTitle": "Inscribirse",
        "newUserSignUp": "¿Nuevo usuario?",
        "signUp": "¡Inscribirse!",
        "alreadyHaveAnAccount": "¿Ya tienes una cuenta?",
        "backToLogin": "Volver a iniciar sesión",
        "registrationDisabled": "El registro está deshabilitado",
        "contactAdmin": "Póngase en contacto con el administrador para solicitar acceso",
        "userNameOrEmail": "Nombre de usuario o correo electrónico",
        "email": "Correo electrónico",
        "emailFormatError": "Por favor, inserte un correo electrónico válido",
        "username": "Nombre de usuario",
        "usernameContainsReservedWord": "El nombre de usuario contiene una palabra reservada, elija otra",
        "usernameFormatError": "El nombre de usuario debe tener al menos 3 caracteres y contener solo letras, números y _",
        "otpCode": "Código de verificación",
        "resendVerificationCode": "Reenviar código",
        "resentVerificationCode": "¡Código de confirmación enviado! ",
        "welcomeTitle": "Bienvenido de nuevo",
        "welcomeDescription": "Ingresa tu código de verificación de 4 dígitos para continuar a tu cuenta",
        "otpTitle": "Ingresa el código de verificación",
        "otpDescription": "Ingresa el código de 4 dígitos que generaste en tu cuenta",
        "otpStep1": "Haz clic en el botón de abajo para abrir tu cuenta",
        "otpStep2": "Genera un código de verificación de 4 dígitos (válido por 60 segundos)",
        "otpStep3": "Regresa aquí e ingresa el código",
        "startOtpLogin": "Iniciar verificación",
        "generateOtp": "Generar código",
        "otpTimer": "El código expira en {{seconds}} segundos",
        "otpInvalidFormat": "Por favor ingresa un código válido de 4 dígitos",
        "otpInvalid": "Código de verificación inválido",
        "otpError": "Error al validar el código. Por favor intenta de nuevo.",
        "otpSuccess": "¡Inicio de sesión exitoso!",
        "otpEmailTitle": "Ingresa tu email",
        "otpEmailDescription": "Ingresa tu dirección de email para recibir un código de verificación",
        "otpCodeDescription": "Ingresa el código de 4 dígitos enviado a {{email}}",
        "emailPlaceholder": "Ingresa tu email",
        "sendOtp": "Enviar código",
        "resendOtp": "Reenviar código",
        "resending": "Reenviando...",
        "backToEmail": "Volver al email",
        "otpSent": "¡Código de verificación enviado!",
        "otpResent": "¡Código reenviado exitosamente!",
        "otpSendError": "Error al enviar el código. Por favor intenta de nuevo.",
        "emailRequired": "Email requerido",
        "emailInvalid": "Por favor ingresa una dirección de email válida",
        "otpNotFound": "Código de verificación no encontrado",
        "otpExpired": "El código de verificación ha expirado",
        "otpMissing": "El código de verificación es requerido",
        "otpSuccessMessage": "¡Verificación exitosa! Redirigiendo...",
        "otpSuccessDescription": "Tu cuenta ha sido verificada exitosamente. Serás redirigido en breve.",
        "otpHelp": "Ingresa el código de 4 dígitos de tu email",
        "emailHelp": "Te enviaremos un código de verificación",
        "userFetchError": "Error al cargar los datos del usuario. Por favor intenta de nuevo.",
        "otpStep1Title": "Ingresa Email",
        "otpStep2Title": "Revisa Email",
        "otpStep3Title": "Ingresa Código",
        "featureFast": "Rápido",
        "featureSecure": "Seguro",
        "featureMobile": "Móvil",
        "password": "Contraseña",
        "newPassword": "Nueva contraseña",
        "confirmPassword": "confirmar Contraseña",
        "currentPassword": "Contraseña actual",
        "passwordMatchingError": "Las contraseñas no coinciden.",
        "passwordFormatError": "La contraseña debe tener al menos 8 caracteres y contener al menos un número, una letra mayúscula, una letra minúscula y un símbolo.",
        "pwdWeak": "Débil",
        "pwdAcceptable": "Aceptable",
        "pwdStrong": "Fuerte",
        "mustChangePassword": "Debes cambiar tu contraseña",
        "passwordChange": "Cambiar la contraseña",
        "emailChange": "Cambiar correo electrónico",
        "avatarChange": "Cambiar avatar",
        "underage": "Debes ser al menos {{age}} años para inscribirse.",
        "optional": "Opcional",
        "birthDate": "Fecha de nacimiento",
        "birthDateHelper": "Solicitamos tu fecha de nacimiento únicamente para habilitar o deshabilitar funcionalidades que tienen restricciones de edad.",
        "missingData": "Información faltante",
        "missingDataHelper": "Sabemos que esto es un poco molesto, pero necesitamos más información para completar tu registro.",
        "goToAccountToChangeYourPreferences": "Puede cambiar su elección en cualquier momento desde la página de su Cuenta.",
        "deepThoughtExplaination": "Deep Thought es una característica avanzada de la IA que te permitirá explotar al máximo tus conversaciones al realizar un seguimiento de ellas. ",
        "tnCAndPPAcceptedHelper": "Desde su último inicio de sesión, los Términos y condiciones y la Política de privacidad han cambiado. ",
        "privacyLabel": "He leído y acepto el",
        "privacyAndCookiePolicy": "Política de privacidad y cookies",
        "and": "y",
        "termsOfService": "Términos de servicio",
        "pAndCUAccepted": "Acepto los términos de servicio sobre Deep Thought",
        "editAccount": "Editar cuenta",
        "save": "Ahorrar",
        "successfullyLoggedIn": "{{username}} ha iniciado sesión correctamente"
    },
    "chatLogs": {
        "anyMessage": "Cualquier mensaje",
        "atLeast": "Al menos {{count}} mensajes",
        "atLeast2": "Al menos 2 mensajes",
        "atLeast3": "Al menos 3 mensajes",
        "atLeast5": "Al menos 5 mensajes",
        "atLeast10": "Al menos 10 mensajes",
        "atLeast15": "Al menos 15 mensajes",
        "atLeast20": "Al menos 20 mensajes",
        "customMinimumMessages": "Personalizar el número de mensajes"
    },
    "success": "Éxito",
    "Error": "Error",
    "internal server error": "Oupsie, lo siento... Algo salió mal en el servidor.",
    "error": "Error",
    "error.loading": "Error al cargar contenido.",
    "error.generic": "Oupsie, lo siento... algo salió mal.",
    "error.serverNotResponding": "Estamos realizando mantenimiento o lanzando actualizaciones. ",
    "error.notFound": "Oupsie, no encontramos la página que buscabas.",
    "error.goBackTo": "Puedes intentar volver al",
    "error.reloadPage": "recargar la pagina",
    "error.tryAgain": "Intentar otra vez",
    "error.unauthorized": "No estás autorizado a ver este contenido.",
    "error.unprocessableEntity": "Error al procesar la solicitud. ",
    "errors": {
        "TENANT_NOT_FOUND": "Inquilino no encontrado",
        "TENANT_REGISTRATION_DISABLED": "El registro en esta plataforma está deshabilitado",
        "TENANT_MISSING_NAME": "Inquilino: falta el nombre",
        "TENANT_MAX_USERS_REACHED": "Número máximo de usuarios alcanzado",
        "TENANT_MAX_ADMINS_REACHED": "Número máximo de usuarios administradores alcanzado",
        "TENANT_ALREADY_EXISTS": "El inquilino ya existe",
        "TENANT_MISSING_DESCRIPTION": "Inquilino: falta descripción",
        "TENANT_CANT_SET_COMPLETION_PROVIDER": "Inquilino: no se puede configurar el proveedor de finalización",
        "TENANT_INVALID_TYPE": "Inquilino: tipo no válido",
        "USER_NOT_CONFIRMED": "Usuario aún no confirmado",
        "USER_NOT_FOUND": "Usuario no encontrado",
        "USER_OR_PASSWORD_INVALID": "Usuario o contraseña no válidos",
        "USER_MUST_CHANGE_PASSWORD": "Debes cambiar tu contraseña",
        "USER_MUST_ENTER_VERIFICATION_CODE": "Debes ingresar el código de verificación",
        "USER_MISSING_TENANT": "Usuario: inquilino desaparecido",
        "USER_MISSING_NAME": "Usuario: falta el nombre",
        "USER_MISSING_PASSWORD": "Usuario: falta contraseña",
        "USER_MISSING_EMAIL": "Usuario: Falta correo electrónico",
        "USER_MISSING_VERIFICATION_CODE": "Usuario: Falta el código de verificación",
        "USER_NAME_ALREADY_USED": "Nombre de usuario ya en uso",
        "USER_PASSWORD_NOT_CONFORMING_TO_POLICY": "La contraseña no cumple con las reglas de seguridad.",
        "USER_EMAIL_ALREADY_USED": "Correo electrónico ya en uso",
        "USER_EMAIL_INVALID": "Correo electrónico no válido",
        "USER_VERIFICATION_CODE_INVALID": "Código de verificación no válido",
        "USER_MISSING_NAME_OR_EMAIL": "Falta nombre de usuario o correo electrónico",
        "USER_NAME_INVALID": "Nombre de usuario no válido",
        "USER_HAS_ONE_OR_MORE_MEMORI": "El usuario tiene uno o más recuerdos.",
        "USER_MISSING_NEW_PASSWORD": "Usuario: falta nueva contraseña",
        "USER_NOTHING_TO_DO": "Nada que hacer",
        "USER_CANT_CREATE_MEMORI": "Usuario no autorizado a crear Agent",
        "USER_MAX_MEMORI_REACHED": "Número máximo de Agent alcanzado",
        "USER_TOO_MANY_ATTEMPTS": "demasiados intentos",
        "USER_MUST_ACCEPT_TNC_AND_PP": "Debes aceptar los términos y condiciones.",
        "USER_BIRTH_DATE_CANT_BE_CHANGED": "La fecha de nacimiento no se puede cambiar.",
        "USER_CANT_SET_COMPLETION_PROVIDER": "Usuario: no tiene permiso para gestionar el proveedor de finalización",
        "USER_CANT_ENABLE_DEEP_THOUGHT": "Usuario: no habilitado para gestionar Deep Thought",
        "USER_CANT_ENABLE_DCM_INTEGRATION": "Usuario: no habilitado para gestionar la integración de DCM",
        "USER_CANT_ENABLE_CHAINING_OR_BOARD_OF_EXPERTS": "Usuario: no se le permite gestionar encadenamiento o grupo de expertos",
        "USER_CREATION_BILLING_DENIED_PERMISSION": "No tienes suficientes créditos para crear un gemelo",
        "USER_HAS_ONE_OR_MORE_COMPLETION_CONFIGS": "El usuario tiene una o más configuraciones de finalización.",
        "USER_CANT_BE_DELETED": "Usuario: no se puede eliminar",
        "USER_ORDER_BY_INVALID": "Orden por no válido",
        "MEMORI_NOT_FOUND": "Memoria no encontrada",
        "MEMORI_NOT_ACCESSIBLE": "Memorias no accesibles",
        "MEMORI_ONLY_OWNER_CAN_CHANGE_GIVER_TAG_AND_PIN": "Sólo el propietario puede cambiar la etiqueta o el pin",
        "SESSION_NOT_FOUND": "Sesión no encontrada",
        "SESSION_IS_NOT_ADMINISTRATIVE": "Sesión no administrativa",
        "SESSION_EXPIRED": "La sesión expiró",
        "SESSION_OTP_NOT_FOUND": "Código de verificación no encontrado",
        "SESSION_OTP_EXPIRED": "El código de verificación ha expirado",
        "SESSION_MISSING_TEMPORARY_TOKEN": "El código de verificación es requerido",
        "MEMORI_MISSING_CONFIGURATION": "Gemelo: falta configuración",
        "MEMORI_CONFIGURATION_NOT_FOUND": "Gemelo: configuración no encontrada",
        "MEMORI_INVALID_PRIVACY_TYPE": "Gemelo: tipo de privacidad no válido",
        "MEMORI_MISSING_PASSWORD": "Gemelo: falta contraseña",
        "MEMORI_INVALID_TOTAL_NUMBER_OF_RECOVERY_TOKENS": "Gemelo: número total de tokens de recuperación no válidos",
        "MEMORI_INVALID_MINIMUM_NUMBER_OF_RECOVERY_TOKENS": "Gemelo: número mínimo de tokens de recuperación no válidos",
        "MEMORI_INVALID_VOICE_TYPE": "Gemelo: tipo de voz no válido",
        "MEMORI_MISSING_NAME": "Gemelo: falta nombre",
        "MEMORI_MISSING_PASSWORD_OR_RECOVERY_TOKENS": "Gemelo: falta contraseña o token de recuperación",
        "MEMORI_INVALID_ID": "Gemelo: identificación no válida",
        "MEMORI_NAME_ALREADY_USED": "Nombre gemelo ya en uso",
        "MEMORI_INVALID_PIN": "Gemelo: PIN no válido",
        "MEMORI_GIVER_TAG_PIN_CHANGE_REQUIRES_SEPARATE_OPERATION": "Gemelo: el cambio de TAG y PIN requiere operaciones separadas",
        "MEMORI_NO_PASSWORD_WHEN_PUBLIC": "Agent: no se requiere contraseña cuando es público",
        "MEMORI_DEEP_THOUGHT_REQUIRES_COMPLETIONS": "Deep Thought requiere que las completaciones estén habilitadas",
        "MEMORI_BOARD_OF_EXPERTS_REQUIRES_COMPLETIONS": "El grupo de expertos requiere que se habiliten las completaciones.",
        "MEMORI_INVALID_COMPLETION_CONFIG": "Gemelo: configuración de finalizaciones no válidas",
        "MEMORI_MACRO_FUNCTIONS_REQUIRES_COMPLETIONS": "Macro funciones requiere que se habiliten las finalizaciones",
        "MEMORI_BLOCKING_DATE_MISSING_OR_WRONG": "Gemelo: fecha de bloqueo faltante o incorrecta",
        "MEMORI_LIST_FILTER_NOT_SPECIFIED": "Gemelo: filtro no especificado",
        "MEMORI_TRANSFER_MISSING_DESTINATION_USER": "Transferencia: falta usuario de destino",
        "MEMORI_TRANSFER_INVALID_DESTINATION_USER_ID": "Transferencia: ID de usuario de destino no válido",
        "MEMORI_TRANSFER_DESTINATION_USER_DATA_INCONSISTENT": "Transferencia: datos de usuario de destino no válidos",
        "MEMORI_TRANSFER_NOTHING_TO_DO": "Transferencia: nada que hacer",
        "MEMORI_CONFIGURATION_CANT_BE_CHANGED": "Memorias: la configuración no se puede cambiar",
        "MEMORI_MISSING_NEW_PASSWORD": "Recuerdos: falta nueva contraseña",
        "MEMORI_FEATURE_REQUIRES_SUBSCRIPTION": "La función requiere suscripción",
        "INTEGRATION_NOT_FOUND": "Integración no encontrada",
        "MEMORI_SESSIONS_INVALID_DATE_FROM_FORMAT": "Fecha no válida del formato",
        "MEMORI_SESSIONS_INVALID_DATE_TO_FORMAT": "Fecha no válida para formatear",
        "MEMORI_SESSION_NOT_FOUND": "Sesión no encontrada",
        "MEMORI_SESSION_DOESNT_ACCEPT_MEDIA": "Sesión no acepta medios",
        "INTEGRATION_INVALID_TYPE": "Tipo de integración no válido",
        "INTEGRATION_ALREADY_EXISTS": "La integración ya existe",
        "INTEGRATION_MEMORI_IS_NOT_PUBLIC": "Las memorias no públicas no se pueden integrar",
        "INTEGRATION_MISSING_INVOCATION_TEXT": "Integración: falta texto de invocación",
        "INTEGRATION_MISSING_DEVICE_EMAILS": "Integración: correo electrónico del dispositivo perdido",
        "INTEGRATION_MEMORI_IS_EMPTY": "Los recuerdos vacíos no se pueden integrar",
        "INTEGRATION_MISSING_PRIVACY_POLICY": "Integración: falta la política de privacidad",
        "INTEGRATION_MISSING_CATEGORY": "Falta categoría de integración",
        "INTEGRATION_MISSING_DESCRIPTION": "Falta descripción de integración",
        "INTEGRATION_INVALID_INVOCATION_TEXT": "Texto de invocación no válido",
        "INTEGRATION_GOOGLE_NO_MORE_AVAILABLE": "Google Home ya no está disponible",
        "UPLOAD_REQUIRES_MULTIPART_ENCODING": "La carga requiere codificación multiparte",
        "UPLOAD_MISSING_CONTENT_TYPE_BOUNDARY": "Upload: falta límite de tipo de contenido",
        "UPLOAD_MAX_LENGTH_EXCEEDED": "Upload: se superó el tamaño máximo",
        "UPLOAD_FILE_IS_EMPTY": "Upload: archivo vacío",
        "UPLOAD_INVALID_FILE_TYPE_OR_SIGNATURE": "Upload: tipo de archivo o firma no válidos",
        "UPLOAD_MISSING_FILE_NAME": "Upload: falta el nombre del archivo",
        "UPLOAD_INVALID_MEMORY_ID": "Upload: ID de contenido no válido",
        "UPLOAD_MISSING_FILE_CONTENT": "Upload: Falta contenido del archivo",
        "ASSET_NOT_FOUND": "Asset no encontrado",
        "ASSET_NOT_ACCESSIBLE": "Asset no accesible",
        "ASSET_MISSING_SESSION_ID": "Asset: ID de sesión faltante",
        "ASSET_INVALID_FILE_NAME": "Asset: nombre de archivo no válido",
        "ASSET_MALWARE_SCAN_THREATS_FOUND": "Asset: encontró amenazas de malware",
        "INVITATION_NOT_FOUND": "Invitación no encontrada",
        "INVITATION_NOT_ACCESSIBLE": "Invitación no accesible",
        "INVITATION_ALREADY_ACCEPTED": "Invitación ya aceptada",
        "INVITATION_ALREADY_REJECTED": "Invitación ya rechazada",
        "INVITATION_MISSING_DESTINATION_EMAIL": "Invitación: falta el correo electrónico de destino",
        "INVITATION_DESTINATION_EMAIL_INVALID": "Invitación: correo electrónico de destino no válido",
        "INVITATION_MISSING_TAG": "Invitación: falta etiqueta",
        "INVITATION_MISSING_PIN": "Invitación: falta el PIN",
        "INVITATION_INVALID_PIN": "Invitación: PIN no válido",
        "INVITATION_INVALID_TYPE": "Invitación: tipo no válido",
        "INVITATION_MISSING_DESTINATION_NAME": "Invitación: falta el nombre del destino",
        "INVITATION_TAG_PIN_CANT_BE_CHANGED": "Invitación: la etiqueta y el pin no se pueden cambiar",
        "INVITATION_CANT_BE_CHANGED": "Intación: no se puede cambiar",
        "ACTIONLOG_INVALID_USER_ID": "ID de usuario no válido",
        "ACTIONLOG_INVALID_DATE_FROM_FORMAT": "Fecha de: formato no válido",
        "ACTIONLOG_INVALID_DATE_TO_FORMAT": "Fecha hasta: formato no válido",
        "ACTIONLOG_INVALID_MEMORI_ID": "ID de memoria no válida",
        "CONSUMPTIONLOG_INVALID_TYPE": "Tipo de registro no válido",
        "CONSUMPTIONLOG_INVALID_DATE_FROM_FORMAT": "Fecha de: formato no válido",
        "CONSUMPTIONLOG_INVALID_DATE_TO_FORMAT": "Fecha hasta: formato no válido",
        "CONSUMPTIONLOG_INVALID_USER_ID": "ID de usuario no válido",
        "CONSUMPTIONLOG_INVALID_MEMORI_ID": "ID de memoria no válida",
        "NOTIFICATIONPREFS_INVALID_CHATLOG_EXTRACTION_PERIOD": "Notificaciones: Período de extracción del registro de chat no válido",
        "BROADCAST_NOT_ALLOWED": "Broadcast no permitido",
        "INVALID_NOTIFICATION_TYPE": "Tipo de notificación no válido",
        "NOTIFICATION_NOT_FOUND": "Notificación no encontrada",
        "INVALID_NOTIFICATION_FILTER": "Filtro de notificación no válido",
        "INVALID_NOTIFICATION_PERIOD": "Período de notificación no válido",
        "PROCESS_INVALID_TYPE": "Tipo de proceso no válido",
        "PROCESS_ALREADY_RUNNING": "Proceso ya en ejecución",
        "PROCESS_NOT_FOUND": "Proceso no encontrado",
        "IMPORTCSV_MISSING_ROWS": "Importación CSV: filas faltantes",
        "IMPORTCSV_MISSING_CSV": "Importación CSV: Falta CSV",
        "IMPORTCSV_MISSING_SEPARATOR": "Importación CSV: falta separador",
        "IMPORTCSV_INVALID_SEPARATOR": "Importación CSV: separador no válido",
        "IMPORTCSV_MISSING_HEADERS": "Importación CSV: faltan encabezados",
        "IMPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "Importación CSV: falta el separador de variante de título",
        "IMPORTCSV_INVALID_RECEIVER_ID": "Importación CSV: ID de receptor no válido",
        "IMPORTCSV_INVALID_MEDIA_LINK": "Importación CSV: enlace multimedia no válido",
        "IMPORTCSV_INVALID_LINK_TITLE_HANDLING": "Importación CSV: título del enlace no válido",
        "IMPORTCSV_UNDETECTABLE_CHAR_ENCODING": "Importación CSV: codificación de caracteres indetectable",
        "IMPORTCSV_CANT_IMPORT_TO_SECRET_MEMORI": "Importación CSV: no se puede importar a Secret Memories",
        "IMPORTTXT_MISSING_ROWS": "Importando TXT: filas faltantes",
        "IMPORTTXT_INVALID_GRANULARITY": "Importar TXT: granularidad no válida",
        "IMPORTTXT_INVALID_RECEIVER_ID": "Importar TXT: ID de receptor no válido",
        "IMPORTTXT_INVALID_MEDIA_LINK": "Importar TXT: enlace multimedia no válido",
        "IMPORTTXT_INVALID_LINK_TITLE_HANDLING": "Importar TXT: título del enlace no válido",
        "IMPORTTXT_UNDETECTABLE_CHAR_ENCODING": "Importación TXT: codificación de caracteres indetectable",
        "IMPORTTXT_CANT_IMPORT_TO_SECRET_MEMORI": "Importación TXT: No se puede importar a Secret Memories",
        "IMPORTTXT_IMPORT_LIMIT_EXCEEDED": "Importar TXT: límite de importación excedido",
        "IMPORTTXT_IMPORT_ON_GPT4_REQUIRES_API_KEY": "Importar TXT: la importación en GPT-4 requiere una clave API",
        "IMPORTTXT_IMPORT_REQUIRES_PAYING": "Importar TXT: la importación requiere un plan de pago",
        "IMPORTTXT_BILLING_DENIED_PERMISSION": "Importar TXT: no tienes suficientes créditos para la operación",
        "IMPORT_MISSING_ROWS": "Importar: filas faltantes",
        "IMPORT_CANT_IMPORT_TO_SECRET_MEMORI": "Importar: no se puede importar a Secret Memories",
        "IMPORTMEMORI_INVALID_MEMORI_SPECS": "Importar MEMORI: especificaciones de memoria no válidas",
        "IMPORT_MISSING_JSONL": "Importar: faltan JSONL",
        "IMPORTMEMORI_INVALID_SPECS": "Importar MEMORI: especificaciones no válidas",
        "EXPORT_MISSING_PASSWORD": "Exportar: falta contraseña",
        "EXPORTCSV_MISSING_CSV_SPECS": "Exportación CSV: faltan especificaciones CSV",
        "EXPORTCSV_MISSING_SEPARATOR": "Exportación CSV: falta separador",
        "EXPORTCSV_INVALID_SEPARATOR": "Exportación CSV: separador no válido",
        "EXPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "Exportación CSV: falta el separador de variante de título",
        "EXPORTCSV_MISSING_NEW_LINE_CHAR": "Exportación CSV: falta un carácter de nueva línea",
        "EXPORTCSV_INVALID_NEW_LINE_CHAR": "Exportación CSV: carácter de nueva línea no válido",
        "EXPORTCSV_MISSING_PASSWORD": "Exportación CSV: falta contraseña",
        "EXPORTJSONL_MISSING_JSONL_SPECS": "Exportación JSONL: faltan especificaciones JSONL",
        "EXPORTJSONL_MISSING_PLATFORM": "Exportación JSONL: plataforma faltante",
        "EXPORTJSONL_INVALID_PLATFORM": "Exportación JSONL: plataforma no válida",
        "EXPORTJSONL_MISSING_PASSWORD": "Exportación JSONL: falta contraseña",
        "EXPORTJSONL_EXPORT_REQUIRES_PAYING": "Exportación JSONL: la exportación requiere un plan pago",
        "ANALYSIS_MISSING_QUERY": "Análisis: consulta faltante",
        "ANALYSIS_CANT_ANALYZE_SECRET_MEMORI": "Análisis: No se pueden analizar recuerdos secretos",
        "ANALYSIS_USER_QUERY_MATCH_REQUIRES_DEEP_THOUGHT": "Análisis: hacer coincidir la consulta del usuario requiere un pensamiento profundo",
        "BADGE_ASSIGNMENT_WRONG_OR_MISSING_CREDENTIALS": "Asignación de insignia: credenciales incorrectas o faltantes",
        "BADGE_ASSIGNMENT_MISSING_REF_ID": "Asignación de insignia: falta el ID de referencia",
        "BADGE_ASSIGNMENT_OUTCOME_NOT_FOUND": "Asignación de insignia: resultado no encontrado",
        "BADGE_ASSIGNMENT_MISSING_ASSERTION_URL": "Asignación de insignia: falta la URL de aserción",
        "BADGE_ASSIGNMENT_MISSING_BADGE_URL": "Asignación de insignia: URL de insignia faltante",
        "BADGE_ASSIGNMENT_MISSING_ISSUER_URL": "Asignación de insignia: falta la URL del emisor",
        "BADGE_ASSIGNMENT_INVALID_URL": "Asignación de insignia: URL no válida",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT": "Asignación de insignia: destinatario faltante",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_TYPE": "Asignación de insignia: tipo de destinatario desconocido",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_IDENTITY": "Asignación de insignia: falta la identidad del destinatario",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_HASH_TYPE": "Asignación de insignia: falta el tipo de hash del destinatario",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_HASH_TYPE": "Asignación de insignia: tipo de hash del destinatario desconocido",
        "BADGE_ASSIGNMENT_WRONG_RECIPIENT_IDENTITY": "Asignación de insignia: identidad del destinatario incorrecta",
        "BADGE_NOT_FOUND": "Insignia no encontrada",
        "OUTCOME_NO_DCM_CONFIGURED": "Resultado: no hay ningún DCM configurado",
        "OUTCOME_USER_BADGES_DISABLED": "Resultado: insignias de usuario deshabilitadas",
        "COMPLETION_CONFIG_MISSING_NAME": "Configuración de terminaciones: falta nombre",
        "COMPLETION_CONFIG_MISSING_PROVIDER": "Configuración de terminaciones: falta proveedor",
        "COMPLETION_CONFIG_MISSING_ENDPOINT": "Configuración de terminaciones: falta punto final",
        "COMPLETION_CONFIG_MISSING_API_KEY": "Configuración de terminaciones: falta clave API",
        "COMPLETION_CONFIG_MISSING_MODEL": "Configuración de terminaciones: modelo faltante",
        "COMPLETION_CONFIG_NO_PURPOSE_SPECIFIED": "Configuración de terminaciones: se debe especificar al menos un tipo de terminaciones",
        "COMPLETION_CONFIG_INVALID_NAME": "Configuración de terminaciones: nombre no válido",
        "COMPLETION_CONFIG_INVALID_PURPOSE": "Configuración de terminaciones: tipo de terminaciones no válidas",
        "COMPLETION_CONFIG_INVALID_ENDPOINT": "Configuración de terminaciones: punto final no válido",
        "COMPLETION_CONFIG_INCONSISTENT_ENDPOINT": "Configuración de terminaciones: punto final inconsistente",
        "COMPLETION_CONFIG_INVALID_PROVIDER": "Configuración de terminaciones: proveedor no válido",
        "COMPLETION_CONFIG_NOT_FOUND": "Configuración de terminaciones: no encontrada",
        "COMPLETION_CONFIG_NOT_ACCESSIBLE": "Configuración de terminaciones: no accesible",
        "COMPLETION_CONFIG_NAME_RESERVED": "Configuración de terminaciones: nombre reservado",
        "COMPLETION_CONFIG_NAME_ALREADY_EXISTS": "Configuración de terminaciones: el nombre ya existe",
        "COMPLETION_CONFIG_VISIBILITY_CHANGE_NOT_ALLOWED": "Configuración de terminaciones: cambio de visibilidad no permitido",
        "COMPLETION_CONFIG_MISSING_MANDATORY_PREFIX": "Configuración de terminaciones: prefijo obligatorio faltante",
        "COMPLETION_CONFIG_VISIBILITY_NOT_PERMITTED": "Configuración de terminaciones: visibilidad no permitida",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_NOT_PERMITTED": "Configuración de terminaciones: uso como predeterminado no permitido",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_REQUIRES_TENANT_VISIBILITY": "Configuración de terminaciones: uso como predeterminado requiere visibilidad del inquilino",
        "COMPLETION_CONFIG_CHARGEABLE_NOT_PERMITTED": "Configuración de terminaciones: chargeable no permitido",
        "COMPLETION_CONFIG_INVALID_APPLY_TO": "Configuración de terminaciones: apply to no válido",
        "COMPLETION_CONFIG_APPLY_TO_TENANT_NOT_ALLOWED": "Configuración de terminaciones: apply to tenant no permitido",
        "TRUSTED_APPLICATION_NOT_FOUND": "Aplicación de confianza no encontrada",
        "TRUSTED_APPLICATION_NOT_ACCESSIBLE": "Aplicación de confianza no accesible",
        "TRUSTED_APPLICATION_NAME_REQUIRED": "Aplicación de confianza: nombre requerido",
        "TRUSTED_APPLICATION_TOKEN_REQUIRED": "Aplicación de confianza: token requerido",
        "TRUSTED_APPLICATION_NAME_ALREADY_EXISTS": "Aplicación de confianza: nombre ya existe",
        "TRUSTED_APPLICATION_INVALID_TOKEN": "Aplicación de confianza: token no válido"
    }
}
